import { render, staticRenderFns } from "./app-footer-minimal.vue?vue&type=template&id=5716519c&scoped=true"
import script from "./app-footer-minimal.vue?vue&type=script&lang=js"
export * from "./app-footer-minimal.vue?vue&type=script&lang=js"
import style0 from "./app-footer-minimal.vue?vue&type=style&index=0&id=5716519c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5716519c",
  null
  
)

export default component.exports